import { BioAuthTrigger, } from "../types";
function isOnLoginBioAuthRequirement(requirement) {
    return (requirement.field === "bio_auth_authentication" &&
        requirement.hasOwnProperty("trigger") &&
        requirement.trigger === BioAuthTrigger.ON_LOGIN);
}
export function getOnLoginBioAuthRequirements(user) {
    var _a;
    var onLoginRequirements = ((_a = user.missingRequirements) === null || _a === void 0 ? void 0 : _a.filter(isOnLoginBioAuthRequirement)) || [];
    return onLoginRequirements.length > 0 ? onLoginRequirements : null;
}
